import { ViewSupport410Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport410Container"
export function ViewSupport410Page() {
    return (
        <ViewSupport410Container />
    )
}